import 'socket.io-client';
import { computed, reactive } from '@vue/reactivity';
import mitt, { Emitter } from 'mitt';
import { ONLINE_STATE_CHANGED } from './constants';
import { Console } from './utils/debugger';

export interface IRootStoreParams {
  client: any;
  socket: SocketIOClient.Socket;
  debug?: boolean;
}

interface IRootStoreState {
  isOnline: boolean;
  isReady: boolean;
  isAuthenticated: boolean;
  authToken: string | null;
}

export class RootStore {
  client: any;
  state: IRootStoreState = reactive({
    isOnline: false,
    isReady: false,
    isAuthenticated: false,
    authToken: null,
  });
  isOnline = computed(() => this.state.isOnline);
  isReady = computed(() => this.state.isReady);
  isAuthenticated = computed(() => this.state.isAuthenticated);
  authToken = computed(() => this.state.authToken);
  registeredServices: string[] = [];
  emitter: Emitter;
  debug: boolean;
  console: ReturnType<typeof Console>;

  constructor({ client, socket, debug }: IRootStoreParams) {
    this.emitter = mitt();
    this.debug = debug || false;

    socket.on('connect', () => {
      this.state.isOnline = true;
      this.console.log('WebSocket is connected');
      this.emitter.emit(ONLINE_STATE_CHANGED, true);
    });

    socket.on('disconnect', () => {
      this.state.isOnline = false;
      this.console.log('WebSocket is disconnected');
      this.emitter.emit(ONLINE_STATE_CHANGED, false);
    });

    this.console = Console(this.debug);
    this.client = client;
  }

  onAuthentication(token: string | null) {
    this.state.isAuthenticated = token ? true : false;
    this.state.authToken = token;
    this.console.log('User is', token ? 'authenticated' : 'not authenticated');
  }

  registerService(name: string) {
    this.console.log('Registered service', name);
    if (!this.registeredServices.includes(name)) {
      this.registeredServices.push(name);
    }
  }
}
